document.addEventListener('DOMContentLoaded', () => {
  // ── State & Elements ──
  const modal            = document.getElementById('lens-modal');
  const steps            = modal.querySelectorAll('.lens-modal__step');
  const panels           = modal.querySelectorAll('[data-step-panel]');
  const addBtn           = document.querySelector('#add-prescription-btn');
  const closeBtn         = modal.querySelector('.lens-modal__close');
  const vp               = document.getElementById('validation-popup');
  const vpBack           = document.getElementById('vp-back');
  const vpContinue       = document.getElementById('vp-continue');
  const showUploadBtn    = document.getElementById('show-upload');
  const showManualBtn    = document.getElementById('show-manual');
  const pdTable          = modal.querySelector('.pd-table');
  const uploadDiv        = modal.querySelector('.prescription-image-upload');
  const fileInput        = document.getElementById('prescription-image');
  const previewWrapper   = document.getElementById('preview-wrapper');
  const previewList      = document.getElementById('preview-list');
  const step3Container   = document.getElementById('step3-options');
  const variantList      = document.getElementById('variant-list');
  const reviewList       = document.getElementById('review-list');
  const readingCard = document.getElementById('reading-card');
  const summaryEl = document.getElementById('selection-summary');
  const body = document.querySelector('body');
  const html = document.querySelector('html');
  const modal_content = document.querySelector('.lens-modal__content');
  let selectedFiles      = [];
  let state              = {};  
  
  // Pull main frame variant
  const productForm      = document.querySelector('form[action^="/cart/add"]');
  const mainVariantInput = productForm.querySelector('select[name="id"], input[name="id"]');
  let mainVariantId      = mainVariantInput.value;
  mainVariantInput.addEventListener('change', e => mainVariantId = e.target.value);

  // Parse the Shopify product JSON for frame info
  const prodJsonEl = document.getElementById('ProductJson-product-template');
  const product    = prodJsonEl ? JSON.parse(prodJsonEl.textContent) : {};

  readingCard.addEventListener('click', e => {
    // prevent it from also bubbling up to your generic `[data-next-step]` logic
    e.stopPropagation();

    readingCard.classList.toggle('is-expanded');
  });

function updateSummary() {
  const parts = [];
  if (state.prescriptionType)    parts.push(state.prescriptionType);
  if (state.prescriptionTypeSub) parts.push(state.prescriptionTypeSub);
  if (state.lensType)            parts.push(state.lensType);
  if (state.color)               parts.push(state.color);
  summaryEl.innerHTML = `You’ve selected <span class="strong">${parts.join(' > ')}</span>`;
}
  let currentStep = '';
function updateStep4Styles(shouldHide) {
    // const hideDiv = document.querySelector('.main-product-info');
    const lensWrapper = document.querySelector('.lens-wrapper');
    
    // if (hideDiv) {
    //     hideDiv.style.display = shouldHide ? "none" : "";
    // }
    if (lensWrapper) {
        lensWrapper.style.padding = shouldHide ? "0" : "";
        lensWrapper.style.border = shouldHide ? "none" : "";
    }
}
  // ── Utility: Show a step by its panel ID (“1”, “1.1”, “2”, …) ──
  function showStep(id) {
    const previousStep = currentStep;
    currentStep = id;

    
    // Reset styles when leaving step 4
    if (previousStep === '4') {
        updateStep4Styles(false);
    }

    
    // update the progress bar
    steps.forEach(s =>
      s.classList.toggle('is-active', +s.dataset.step <= parseFloat(id))
    );
    // show the matching panel, hide the rest
    panels.forEach(p =>
      p.classList.toggle('is-active', p.dataset.stepPanel === id.toString())
    );
        // If we’re landing on step 3 (choose a lens type),
        // wipe out any previous lensType + downstream state:
        if (id === '3') {
          delete state.lensType;
          delete state.color;
          delete state.variant;
        }
        // If we’re landing on step 3.1 (color picker),
        // we want to keep lensType (they just chose it on 3),
        // but *not* show it in the summary – so clear it here:
        else if (id === '3.1') {
          delete state.lensType;
          delete state.variant;
          delete state.color;
        }
        // If we go all the way back before 3, clear everything:
        else if (+id < 3) {
          delete state.lensType;
          delete state.lensHandle;
          delete state.color;
          delete state.variant;
          delete state.prescriptionTypeSub;
        }
      
        // Only show the little “So far…” banner on 3, 3.1, or 4
        if (['3','3.1','4'].includes(id.toString())) {
          updateSummary();
        } else {
          summaryEl.textContent = '';
        }
     // Apply styles when entering step 4
    if (id === '4') {
        updateStep4Styles(true);
    }
  }

  // ── Open & Close handlers ──
function clearVariantErrors() {
  document.querySelectorAll('variant-picker .option-selector').forEach((el) => {
    // Remove prefix span
    el.querySelectorAll('.label__prefix').forEach((prefix) => prefix.remove());
    // Remove error class
    el.querySelectorAll('.label').forEach((label) => {
      label.classList.remove('label--contains-error');
    });
  });
}

function isVariantSelected() {
  // const variantInputs = document.querySelectorAll('.opt-btn[type="radio"]');
  // return Array.from(variantInputs).some(input => input.checked);
   // get all option groups (e.g., Color, Size)
  const optionGroups = [...new Set(
    Array.from(document.querySelectorAll('.opt-btn[type="radio"]'))
      .map(input => input.name)
  )];

  // each group MUST have one checked input
  return optionGroups.every(groupName => {
    return document.querySelector(`.opt-btn[name="${groupName}"]:checked`);
  });
}

// helper: detect whether product has more than one variant option (based on radio inputs)
function hasMultipleVariants() {
  const variantInputs = document.querySelectorAll('.opt-btn[type="radio"]');
  return variantInputs.length > 1;
}

// helper: apply visual error to all option-selectors
function applyVariantErrors() {
  document.querySelectorAll('variant-picker .option-selector').forEach((el) => {
    const label = el.querySelector('.label');
    if (label) {
      label.classList.add('label--contains-error');
      const labelPrefix = document.createElement('span');
      labelPrefix.className = 'label__prefix';
      labelPrefix.innerText = `Choose a frame ${el.dataset.option.toLowerCase()}`;
      label.prepend(labelPrefix);
    }
  });
}
// clear errors when a variant is selected
document.querySelectorAll('.opt-btn[type="radio"]').forEach((input) => {
  input.addEventListener('change', () => {
    if (isVariantSelected()) {
      clearVariantErrors();
    }
  });
});
// click handler
addBtn.addEventListener('click', () => {
  // If there are multiple variants, require selection before opening modal
  if (hasMultipleVariants()) {
    if (!isVariantSelected()) {
      // clearVariantErrors();
      applyVariantErrors();
      return; // stop opening modal
    } 

    // Variant selected → proceed
   
    body.classList.add('overflow-hidden');
    html.classList.add('overflow-hidden');
    modal.classList.remove('hidden');
    showStep('1');
    return;
  }

  // Single (or no) variant: open modal normally
 
  body.classList.add('overflow-hidden');
  html.classList.add('overflow-hidden');
  modal.classList.remove('hidden');
  showStep('1');
});

closeBtn.addEventListener('click', () => {
  body.classList.remove('overflow-hidden');
  html.classList.remove('overflow-hidden');
  modal.classList.add('hidden');
});


  
  // addBtn.addEventListener('click', () => {
  //   body.classList.add('overflow-hidden');
  //   html.classList.add('overflow-hidden');
  //   modal.classList.remove('hidden');
  //   showStep('1');
  // });
  // closeBtn.addEventListener('click', () => {
  //   body.classList.remove('overflow-hidden');
  //   html.classList.remove('overflow-hidden');
  //   modal.classList.add('hidden');
  // });

  // ── Validation popup ──
  vpBack.addEventListener('click', () => {
    modal_content.classList.remove('overflow-hidden')
    vp.classList.add('hidden')
  });
  vpContinue.addEventListener('click', () => {
    modal_content.classList.remove('overflow-hidden')
    vp.classList.add('hidden');
    // force move to step 3 even if missing fields
    showStep('3');
    loadStep3Products(state.lensCollection);
  });

  // ── PD Upload vs Manual toggle ──
  showUploadBtn.addEventListener('click', () => {
    pdTable.classList.add('hidden');
    uploadDiv.classList.remove('hidden');
    showUploadBtn.classList.add('hidden');
    showManualBtn.classList.remove('hidden');
  });
  showManualBtn.addEventListener('click', () => {
    uploadDiv.classList.add('hidden');
    pdTable.classList.remove('hidden');
    showManualBtn.classList.add('hidden');
    showUploadBtn.classList.remove('hidden');
  });

  // ── Prescription image preview ──
  fileInput.addEventListener('change', () => {
    Array.from(fileInput.files).forEach(f => selectedFiles.push(f));
    fileInput.value = '';
    refreshPreview();
  });
  function refreshPreview() {
    previewList.innerHTML = '';
    if (!selectedFiles.length) {
      previewWrapper.classList.add('hidden');
      return;
    }
    selectedFiles.forEach((file, i) => {
      const reader = new FileReader();
      reader.onload = e => {
        const wrap = document.createElement('div'), img = document.createElement('img'), btn = document.createElement('button');
        wrap.className = 'thumb-wrap';
        img.src = e.target.result; img.alt = file.name; img.className = 'preview-thumb';
        btn.type = 'button'; btn.textContent = '✕'; btn.className = 'remove-thumb';
        btn.addEventListener('click', () => {
          selectedFiles.splice(i,1);
          refreshPreview();
        });
        wrap.append(img,btn);
        previewList.append(wrap);
      };
      reader.readAsDataURL(file);
    });
    previewWrapper.classList.remove('hidden');
  }

  // ── Load Step 3 products from a collection handle ──
  // async function loadStep3Products(collectionHandle) {
  //   if (!collectionHandle) return;
  //   step3Container.innerHTML = '<p>Loading…</p>';
  //   try {
  //     const resp = await fetch(`/collections/${collectionHandle}/products.json?limit=50`);
  //     const json = await resp.json();
  //     console.log("Fetched Product", json)
  //     step3Container.innerHTML = '';

  //     const rawCollectionName = collectionHandle.replace(/-/g, ' ');
      
  //     json.products.forEach((p,index) => {
  //       const btn = document.createElement('div');
  //       btn.className = 'option-card';
  //       btn.dataset.nextStep = '4';
  //       btn.dataset.productHandle = p.handle;

  //       const displayTitle = p.title.replace(new RegExp(`^${rawCollectionName}\\s*[-–:\\s]*`, 'i'),'').trim();
     

  //       const description = p.body_html;

  //       const price = p.variants[0]?.price ? `$${(parseFloat(p.variants[0].price))}` : '';
        
  //       btn.innerHTML = `
  //         <div class="option-card-left">
  //             <img src="${p.images[0]?.src||''}" alt="${p.title}">
  //         </div>
  //         <div class="option-card-right">
  //             <div class="title-and-price">
  //                 <h3>${displayTitle}</h3>
  //                 <div class="price">from <span class="price-bold">${price}</span></div>
  //             </div>
  //             <p>${description}</p>
  //             <div class="custom-modal-trigger index-${index} learn-more" data-modal-id="learn-more-${index}">Learn more</div>
  //         </div>
  //       `;
  //       btn.addEventListener('click', async (e) => {

  //                 if (e.target.closest('.custom-modal-trigger')) {
  //                    const modalId = e.target.closest('.custom-modal-trigger').getAttribute('data-modal-id');
  //                   openModal(modalId);
  //                   return; // Skip button action if clicked on Learn more
  //                 }
          
  //                 state.lensHandle = p.handle;
  //                 state.lensType = displayTitle;
  //                 state.lensName = p.title;
  //                 // check if this product has a Color option
  //                 const hasColor = p.options.some(option => option.name === "Color");
  //                 if (hasColor) {
  //                   // build color‐buttons
  //                   const container = document.getElementById('color-options');
                    
  //                   container.innerHTML = '';
                 
  //                    // Create a map of color values to their variant images
  //                     const colorImageMap = {};
  //                     p.variants.forEach(variant => {
  //                         const colorValue = variant.option1; // Assuming color is option1
  //                         if (!colorImageMap[colorValue] && variant.featured_image) {
  //                             colorImageMap[colorValue] = variant.featured_image.src;
  //                         }
  //                     });

  //                   const description = p.body_html
                    
  //                   p.options.forEach(option => {
                    
  //                     option.values.forEach(colorValue => {
  //                           if(option.name === 'Color') {
                            
  //                             const cbtn = document.createElement('button');
  //                               cbtn.className = 'option-card';
  //                               cbtn.dataset.color = colorValue;
  //                               cbtn.textContent = colorValue;

  //                               // Use variant image if available, otherwise use product image
  //                               const imageUrl = colorImageMap[colorValue] || p.images[0]?.src || '';

  //                               cbtn.innerHTML = `
  //                                   <div class="option-card-left">
  //                                       ${imageUrl ? `<img src="${imageUrl}" alt="${colorValue}">` : ''}
  //                                   </div>
  //                                   <div class="option-card-right">
  //                                       <div class="title-and-price">
  //                                           <h3>${colorValue}</h3>
  //                                           <div class="price">from <span class="price-bold">${price}</span></div>
  //                                       </div>
  //                                       <p>${description}</p>
  //                                   </div>
  //                               `;
                              
  //                               cbtn.addEventListener('click', async () => {
  //                                 state.color = colorValue;
  //                                 variantList.innerHTML = '<div class="loading-indicator">Loading...</div>';
  //                                 showStep('4');
  //                                 await loadVariants(p.handle, colorValue);
  //                               });
  //                               container.append(cbtn);
  //                           }
  //                     });
  //                   });
   
  //                   // go to step 3.1
  //                   showStep('3.1');
  //               } else {
  //                 // no color choice → just go straight to variants
  //                 variantList.innerHTML = '<div class="loading-indicator">Loading variants...</div>';
  //                 showStep('4');
  //                 await loadVariants(p.handle);
  //               }
  //             });

  //       step3Container.append(btn);
  //     });
  //   } catch(err) {
  //     step3Container.innerHTML = '<p class="error">Failed to load lenses.</p>';
  //     console.error(err);
  //   }
  // }



//  Client-side renderer: reads collection-meta-<handle> blob and renders option cards 

async function loadStep3Products(collectionHandle) {
  if (!collectionHandle) return;
  step3Container.innerHTML = '<p>Loading…</p>';

  // find pre-rendered JSON blob
  const blobEl = document.getElementById(`collection-meta-${collectionHandle}`);
  let products = [];

  if (blobEl) {
    try {
      const data = JSON.parse(blobEl.textContent);
      products = Array.isArray(data.products) ? data.products : [];
      // console.log('Loaded products from Liquid blob for', collectionHandle, products.length);
    } catch (err) {
      console.error('Failed parsing collection blob', err);
      products = [];
    }
  }

  // fallback to REST product list (without metafields)
  if (!products.length) {
    try {
      const resp = await fetch(`/collections/${collectionHandle}/products.json?limit=50`);
      const json = await resp.json();
      products = (json.products || []).map(p => ({
        handle: p.handle,
        title: p.title,
        body_html: p.body_html || '',
        images: [{ src: p.images[0]?.src||'' }],
        price: p.variants && p.variants[0] ? p.variants[0].price : null,
        options: p.options || [],
        metafields: {}
      }));
      console.warn('No Liquid blob present; loaded products without metafields.');
    } catch (err) {
      step3Container.innerHTML = '<p class="error">Failed to load lenses.</p>';
      console.error(err);
      return;
    }
  }

  // render cards
  step3Container.innerHTML = '';
  const rawCollectionName = collectionHandle.replace(/-/g, ' ');

  products.forEach((p, index) => {
    const titleFromMeta = (p.metafields && (p.metafields.badge_text || p.metafields.custom_title)) || p.title;
    const displayTitle = p.title.replace(
      new RegExp(`^${rawCollectionName}\\s*[-–:\\s]*`, 'i'),
      ''
    ).trim();

    const price = p.price ? p.price : '';
    const imgSrc = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';


    const btn = document.createElement('div');
    btn.className = 'option-card';
    btn.dataset.nextStep = '4';
    btn.dataset.productHandle = p.handle;

    // build badge if metafield present
    let badgeHtml = '';
    const badgeText = p.metafields && p.metafields.badge_text ? p.metafields.badge_text : '';
    const badgeColor = p.metafields && p.metafields.badge_color ? p.metafields.badge_color : '';

    if (badgeText) {
      // inline style uses a safe default; you can move to CSS classes if preferred
      const safeColor = badgeColor ? badgeColor : '#1a6dcc';
      badgeHtml = `<div class="modal-badge" style="display:inline-block;padding:4px 8px;border-radius:8px;font-size:12px;font-weight:600;background:${safeColor};color:#fff;min-width: max-content;text-align: center;">${badgeText}</div>`;
    }

    btn.innerHTML = `
      <div class="option-card-left">
        ${ imgSrc ? `<img src="${imgSrc}" alt="${p.title}">` : '' }
         <div class="custom-modal-trigger index-${index} learn-more" data-modal-id="learn-more-${index}">
            

              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 800 800" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
    <g transform="matrix(1.74664,0,0,1.74642,-252.1,-60.7251)">
        <g id="Ebene1">
            <g>
                <g transform="matrix(3.48575,0,0,3.48575,-650.368,-420.328)">
                    <circle cx="293.685" cy="196.267" r="65.165" style="fill:rgb(185,185,185);"/>
                </g>
                <g transform="matrix(3.08698,0,0,3.08698,-779.162,-550.57)">
                    <path d="M383.686,244.808L383.686,311.2L393.411,311.2L393.411,318.84L354.496,318.84L354.496,311.2L363.406,311.2L363.406,255.222L354.496,251.655L354.496,244.808L383.686,244.808Z" style="fill:white;"/>
                </g>
                <g transform="matrix(3.22886,0,0,3.22886,-797.323,-547.116)">
                    <circle cx="362.95" cy="211.755" r="11.84" style="fill:white;"/>
                </g>
            </g>
        </g>
    </g>
</svg>


         </div> 
      </div>
      <div class="option-card-right cstm">
        <div class="title-and-price" style="display:flex;align-items:center;gap:8px;">
          <h2 style="margin:0">${displayTitle}</h2>
           <!-- <div class="hide-mob">${badgeHtml}</div> 
          hide-mob -->
          <h3 class="priceLens">from <span class="price-bold">${price}</span></h3>
        </div>
        <div class="price-and-text">
            <div>${p.body_html || ''}</div>
            <div class="p-container">
                <!-- <h3 class="price show-mob">from <span class="price-bold">${price}</span></h3> -->
                <div class="">${badgeHtml}</div>
            </div>
        </div>
        <!--  <div class="custom-modal-trigger index-${index} learn-more" data-modal-id="learn-more-${index}">Learn more</div> -->
      </div>
    `;

    btn.addEventListener('click', async (e) => {
      if (e.target.closest('.custom-modal-trigger')) {
        const modalId = e.target.closest('.custom-modal-trigger').getAttribute('data-modal-id');
        openModal(modalId);
        return;
      }

      state.lensHandle = p.handle;
      state.lensType = displayTitle;
      state.lensName = p.title;

      const hasColorOption = (p.options || []).some(opt => /color|colour/i.test(opt.name || opt));
      if (hasColorOption) {
        // populate color picker using option values
        const container = document.getElementById('color-options');
        container.innerHTML = '';

        const colorOpt = (p.options || []).find(opt => /color|colour/i.test(opt.name || opt));
        const colorValues = colorOpt ? colorOpt.values : [];

        colorValues.forEach(colVal => {
          const cbtn = document.createElement('button');
          cbtn.className = 'option-card';
          cbtn.dataset.color = colVal;
          // if you stored a single product-level custom_image, it will be used for all colors;
          // for per-color images you'd need to include a mapping in the JSON blob.
          const colorImg = (p.metafields && p.metafields.custom_image) ? p.metafields.custom_image : imgSrc;
          cbtn.innerHTML = `
            <div class="option-card-left">${ colorImg ? `<img src="${colorImg}" alt="${colVal}">` : '' }</div>
            <div class="option-card-right">
              <div class="title-and-price"><h3>${colVal}</h3><div class="priceLens">from <span class="price-bold">${price}</span></div></div>
              <p>${p.body_html || ''}</p>
            </div>
          `;
          cbtn.addEventListener('click', async () => {
            state.color = colVal;
            variantList.innerHTML = '<div class="loading-indicator">Loading...</div>';
            showStep('4');
            await loadVariants(p.handle, colVal);
          });
          container.append(cbtn);
        });

        showStep('3.1');
      } else {
        variantList.innerHTML = '<div class="loading-indicator">Loading variants...</div>';
        showStep('4');
        await loadVariants(p.handle);
      }
    });

    step3Container.append(btn);
  });
}









async function loadVariants(handle, colorFilter) {
   variantList.innerHTML = '<div class="loading-indicator">Loading...</div>';
  // 1) Updated GraphQL query (no changes here from the previous fix)
 const graphqlQuery = /* GraphQL */ `
    query getProductVariants($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
        variants(first: 50) {
          nodes {
            id
            title
            priceV2 {
              amount
              currencyCode
            }
            selectedOptions {
              name
              value
            }
            image {
              url
            }
            metafields(identifiers: [
              { namespace: "custom", key: "recommend_this" }
              { namespace: "custom", key: "custom_image" }
              { namespace: "custom", key: "custom_title" }
              { namespace: "custom", key: "text_1" }
              { namespace: "custom", key: "text_2" }
              { namespace: "custom", key: "text_3" }
              { namespace: "custom", key: "text_4" }
              { namespace: "custom", key: "offer_text" }
            ]) {
              namespace
              key
              value
              reference {
                ... on MediaImage {
                  image {
                    url(transform: { maxWidth: 300, maxHeight: 300 })
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  // 2) Fetch via GraphQL
  let graphResponse;
  try {
    graphResponse = await fetch("/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        // ← Replace with your actual Storefront Access Token
        "X-Shopify-Storefront-Access-Token": "dd85df2a8576a06bf7e76bd37225ee48"
      },
      body: JSON.stringify({
        query: graphqlQuery,
        variables: { handle }
      })
    });
  } catch (networkError) {
    console.error("Network error when fetching variants:", networkError);
    variantList.innerHTML = `<p class="error">Failed to load variants. Please try again.</p>`;
    return;
  }

  const graphJson = await graphResponse.json();
  if (graphJson.errors) {
    console.error("GraphQL errors:", graphJson.errors);
    variantList.innerHTML = `<p class="error">Error loading variants. Check console for details.</p>`;
    return;
  }

  const productNode = graphJson.data.productByHandle;
  if (!productNode) {
    console.error(`No product found with handle '${handle}'.`);
    variantList.innerHTML = `<p class="error">No such product found.</p>`;
    return;
  }

  // 3) Map each variant node into a simpler JS object
  const allVariants = productNode.variants.nodes.map(v => {

        const parseVariantId = (gid) => {
          const parts = gid.split('/');
          return parts[parts.length - 1];
        };
    // Build metafield map with special handling for images
    const mfMap = {};
    v.metafields.forEach(mf => {
      if (!mf || mf.key == null) return;
      
      // Handle MediaImage references
      if (mf.key === 'custom_image' && mf.reference?.image?.url) {
        mfMap.custom_image = mf.reference.image.url;
      } 
      // Handle other metafields
      else {
        mfMap[mf.key] = mf.value;
      }
    });

    // Build an options map (e.g. Color → "Blue")
    const optionMap = {};
    v.selectedOptions.forEach(opt => {
      optionMap[opt.name] = opt.value;
    });

    // 4) Safely extract an image URL:
    //    - If metamap.custom_image is valid JSON, parse it and grab `.src`
    //    - Otherwise assume it’s already a URL string
    //    - Only if no custom_image, fall back to v.image.url
    let imageUrl = "";
    if (mfMap.custom_image) {
      try {
        // Try to parse JSON (e.g. { "src": "https://..." })
        const parsed = JSON.parse(mfMap.custom_image);
        imageUrl = parsed.src || "";
      } catch {
        // If parsing fails, assume it’s already a URL
        imageUrl = mfMap.custom_image;
      }
    } 
    if (!imageUrl && v.image) {
      imageUrl = v.image.url;
    }

    return {
      id:         parseVariantId(v.id),
      title:      v.title,
      price:      parseFloat(v.priceV2.amount),
      currency:   v.priceV2.currencyCode,
      imageUrl,                     // either custom_image or variant.image.url
      metafields: mfMap,
      options:    optionMap
    };
  });

  // 5) Filter by colorFilter (if provided)
  const filtered = allVariants.filter(v => {
    if (!colorFilter) return true;
    return v.options["Color"] === colorFilter;
  });

  // 6) Clear any existing cards
  variantList.innerHTML = "";

  // 7) Build each “variant-card” exactly like your design
  filtered.forEach(v => {
    const card = document.createElement("div");
    // card.className = "variant-card ";
    card.className = "option-card";
    card.dataset.variantId = v.id;

    const cardLeft = document.createElement("div")
    cardLeft.className = "option-card-left small-height"
    card.appendChild(cardLeft);


      if (v.imageUrl) {
      const img = document.createElement("img");
      img.src = v.imageUrl;
      img.alt = v.title;
      cardLeft.appendChild(img);
    }

    const cardRight = document.createElement("div")
    cardRight.className = "option-card-right mob-option-right"
    card.appendChild(cardRight);


    const titlePriceWrapper = document.createElement("div")
    titlePriceWrapper.className = "title-and-price cstm"
    titlePriceWrapper.style.display = "flex";
    titlePriceWrapper.style.alignItems = "center";
    titlePriceWrapper.style.gap = "8px";
    cardRight.appendChild(titlePriceWrapper);

    const titleText = v.metafields.custom_title || v.title;
    const h3 = document.createElement("h3")
    h3.textContent = titleText;
    titlePriceWrapper.appendChild(h3);

    const priceP = document.createElement("div");
    priceP.className = "priceLens";
    priceP.textContent = `$${v.price.toFixed(2)}`;
    titlePriceWrapper.appendChild(priceP);

      // Append metafield paragraphs right after h3
      ["text_1", "text_2"].forEach(key => {
        if (v.metafields[key]) {
          const p = document.createElement("p");
          p.classList.add("hide-mob");
          p.textContent = v.metafields[key];
          cardRight.appendChild(p);
        }
      });

       // Append metafield paragraphs to option-card
      ["text_1", "text_2"].forEach(key => {
        if (v.metafields[key]) {
          const p = document.createElement("p");
          p.classList.add("show-mob", "mobile-para");
          p.textContent = v.metafields[key];
          card.appendChild(p);
        }
      });

    // 7a) “RECOMMENDED” ribbon if recommend_this is the string "true"
    // if (v.metafields.recommend_this === "true") {
    //   const ribbon = document.createElement("div");
    //   ribbon.className = "ribbon";
    //   ribbon.textContent = "RECOMMENDED";
    //   card.appendChild(ribbon);
    //   card.classList.add("recommend");
    // } 
     // 7b) Image container (light-blue background is handled by CSS)
    // if (v.imageUrl) {
    //   const img = document.createElement("img");
    //   img.src = v.imageUrl;
    //   img.alt = v.title;
    //   card.appendChild(img);
    // }
    //     const wrapper = document.createElement("div")
    // wrapper.className = "title-and-price"
    // card.appendChild(wrapper)

     

    // 7c) Title (custom_title or fallback to variant.title)
    // const titleText = v.metafields.custom_title || v.title;
    // const h3 = document.createElement("h3");
    // h3.textContent = titleText;
    // wrapper.appendChild(h3);

    // 7d) Price
    // const priceP = document.createElement("p");
    // priceP.className = "price";
    // priceP.textContent = `$${v.price.toFixed(2)}`;
    // wrapper.appendChild(priceP);

  



    // 7e) Bullet list from text_1…text_4
    // const bullets = [];
    // ["text_1", "text_2", "text_3", "text_4"].forEach(key => {
    //   if (v.metafields[key]) {
    //     bullets.push(`
    //     <li><svg style="margin-right: 5px;" width="16px" height="16px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4cd07d">
    //       <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
    //     </svg>
    //       ${v.metafields[key]}</li>
    //     `);
    //   }
    // });
    // if (bullets.length) {
    //   const ul = document.createElement("ul");
    //   ul.className = "features";
    //   ul.innerHTML = bullets.join("");
    //   card.appendChild(ul);
    // }

    // 7f) Offer bubble if offer_text exists
    // if (v.metafields.offer_text) {
    //   const offer = document.createElement("div");
    //   offer.className = "offer-bubble";
    //   offer.textContent = v.metafields.offer_text;
    //   card.appendChild(offer);
    // }
    

    // 7g) “Select” button
    // const btn = document.createElement("button");
    // btn.textContent = "Select";
    // card.appendChild(btn);

    // const hideDiv = document.querySelector('.main-product-info')
    // hideDiv.style.display = "none"
    const lensWrapper = document.querySelector('.lens-wrapper')
    // lensWrapper.style.padding = "0"
    // lensWrapper.style.border = "none"

    // 8) Click handler to mark selected + store state.variant + move to step 5
    card.addEventListener("click", () => {
      // Remove .is-selected from any other card
      // variantList.querySelectorAll(".variant-card").forEach(other => {
      //   other.classList.remove("is-selected");
      // });
      // card.classList.add("is-selected");

      state.variant = v;
      buildReview();
      showStep("5");
    });

    variantList.appendChild(card);
  });

  // 9) If nothing matched, show a “no variants” message
  if (filtered.length === 0) {
    variantList.innerHTML = `<p class="error">No variants found.</p>`;
  }
}



  async function buildReview() {
  reviewList.innerHTML = '';

  // Frame variant
  const mainVar = product.variants.find(v => v.id == mainVariantId) || {};

  // Safe lens tech string
  const lensTech = state.variant?.metafields?.custom_title || state.variant?.title || '';

  // 1) Frame + lens meta
  const ul = document.createElement('ul');
  ul.className = 'review-meta';
  // <li><strong>Frame size:</strong> ${(mainVar.options || []).join(' – ')}</li>
  ul.innerHTML = `
    <li><strong>Your frame:</strong> ${product.title}</li>
    <li><strong>Prescription type:</strong> ${state.prescriptionType}</li>
     ${
    state.prescriptionType !== 'Frame Only'
      ? `<li><strong>Lens Technology:</strong> ${lensTech}</li>`
      : ''
    }
  `;
  reviewList.append(ul);

  // 2) If Frame Only, just show frame add-to-cart, a back button, and exit
  if (state.prescriptionType === 'Frame Only') {
    const addFrame = document.createElement('button');
    addFrame.className = 'btn-primary';
    addFrame.textContent = 'Add to Cart';
    addFrame.addEventListener('click', async () => {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: mainVariantId, quantity: 1 })
      });
      window.location.href = '/cart';
    });

    const backBtn = document.createElement('button');
    backBtn.className = 'back-btn';
    backBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path>
      </svg>
      <span>Back</span>
    `;
    backBtn.addEventListener('click', () => showStep('1'));

    reviewList.append(addFrame, backBtn);
    return;
  }

  // 3) Collapsible Rx details (skip for Non-Prescription if no Rx data)
  if (state.prescriptionType !== 'Non‑Prescription') {

    // decide whether to include the ADD column
    const showAdd = state.prescriptionType !== 'Single Vision';
    
    const coll = document.createElement('button');
    coll.className = 'collapsible';
    coll.innerHTML = `Prescription details 
    <span>
      <svg width="16px" height="16px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
      </svg>
    </span>`;

    const details = document.createElement('div');
    details.className = 'content hidden';

     // build table header
    let thead = `<tr>
      <th></th>
      <th>SPH</th>
      <th>CYL</th>
      <th>Axis</th>
      ${ showAdd ? '<th>ADD</th>' : '' }
      <th>PD</th>
    </tr>`;

     // build each row
    const odAddCell = showAdd ? `<td>${state.add_od || '--'}</td>` : '';
    const osAddCell = showAdd ? `<td>${state.add_os || '--'}</td>` : '';
    
      details.innerHTML = `
            <table class="review-table">
              <thead>${thead}</thead>
              <tbody>
                <tr>
                  <td>OD</td>
                  <td>${state.sphere_od || '--'}</td>
                  <td>${state.cyl_od   || '--'}</td>
                  <td>${state.axis_od  || '--'}</td>
                  ${odAddCell}
                  <td>${state.pd_right || state.pd || '--'}</td>
                </tr>
                <tr>
                  <td>OS</td>
                  <td>${state.sphere_os || '--'}</td>
                  <td>${state.cyl_os    || '--'}</td>
                  <td>${state.axis_os   || '--'}</td>
                  ${osAddCell}
                  <td>${state.pd_left  || state.pd || '--'}</td>
                </tr>
              </tbody>
            </table>
          `;
    
    coll.addEventListener('click', () => details.classList.toggle('hidden'));
    reviewList.append(coll, details);
  }

  // 4) Subtotal & Add both items to cart
  const lensVar = state.variant || {};
  // Convert frame price from cents to dollars
  const framePrice = (mainVar.price || 0) / 100;
  
  // Lens price is already in dollars from GraphQL
  const lensPrice = state.variant?.price || 0;
  
  const subtotal = framePrice + lensPrice;
  const subDiv = document.createElement('div');
  subDiv.className = 'subtotal';
  subDiv.innerHTML = `<strong>Subtotal:</strong> $${subtotal.toFixed(2)}`;

  const actions = document.createElement('div');
  actions.className = 'review-actions';

  const toCart = document.createElement('button');
  toCart.id = 'add-to-cart-btn';
  toCart.className = 'btn-primary';
  toCart.textContent = 'Add to cart';
 
toCart.addEventListener('click', async () => {
  // Generate unique bundle ID
  
  // Build lens properties
  const lensProperties = {
    Frame: product.title,
    Prescription: state.prescriptionType,
    PD: state.pd,
    Sphere_OD: state.sphere_od,
    Sphere_OS: state.sphere_os,
    Cyl_OD: state.cyl_od,
    Cyl_OS: state.cyl_os,
    Axis_OD: state.axis_od,
    Axis_OS: state.axis_os,
    Add_OD: state.add_od,
    Add_OS: state.add_os,
  };

  // Filter out empty values
  const filteredLensProperties = {};
  for (const [key, value] of Object.entries(lensProperties)) {
    if (value !== '--' && value !== undefined && value !== '') {
      filteredLensProperties[key] = value;
    }
  }

  // Create items array
  const items = [
    // Lens item
    {
      id: state.variant.id,
      quantity: 1,
      properties: filteredLensProperties
    },
    // Frame item
    { 
      id: mainVariantId,
      quantity: 1,
      properties: {
          "Lens": state.lensName 
        }
    }
  ];

  // Create FormData and append items
  const fd = new FormData();
  
  // Append items using Shopify's expected format
  items.forEach((item, index) => {
     fd.append(`items[${index}][id]`, item.id);
    fd.append(`items[${index}][quantity]`, item.quantity);
    
    // Append properties
    if (item.properties) {
      for (const [key, value] of Object.entries(item.properties)) {
        fd.append(`items[${index}][properties][${key}]`, value);
      }
    }
  });

  // Append prescription images
  selectedFiles.forEach((file, index) => {
      fd.append(
      `items[0][properties][Prescription Image ${index + 1}]`, 
      file, 
      file.name
    );
  });

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd
    });

    if (response.ok) {
      const data = await response.json();
      console.log('Cart add successful:', data);
      window.location.href = '/cart';
    } else {
      console.error('Cart add failed', response);
      
      // Try to get error details
      try {
        const errorData = await response.json();
        console.error('Error details:', errorData);
        alert(`Error: ${errorData.description || 'Failed to add to cart'}`);
      } catch (e) {
        console.error('Failed to parse error response', e);
        alert('Failed to add to cart. Please check your selections and try again.');
      }
    }
  } catch (error) {
    console.error('Network error:', error);
    alert('Network error. Please check your connection and try again.');
  }
});
  const back5 = document.createElement('button');
  back5.className = 'back-btn';
  back5.innerHTML = `
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='1.5' stroke='currentColor'>
    <path stroke-linecap='round' stroke-linejoin='round' d='M15.75 19.5 8.25 12l7.5-7.5'></path>
  </svg>
  <span>Back</span>
`;
  back5.addEventListener('click', () => showStep('4'));

  actions.append(subDiv, toCart, back5);
  reviewList.append(actions);
}

  // ── Generic next/prev wiring ──
  modal.querySelectorAll('[data-next-step]').forEach(btn => {
    btn.addEventListener('click', async e => {
      const target = e.currentTarget.dataset.nextStep;

    const isSingleVision = e.currentTarget.dataset.prescriptionType === 'Single Vision';
    const prescriptionTable = document.querySelector('.pd-table');
    
    // Toggle 'hide-add' class based on prescription type
    prescriptionTable.classList.toggle('hide-add', isSingleVision);
      
      state.prescriptionType = btn.dataset.prescriptionType;
      if (btn.dataset.lensCollection) {
        state.lensCollection = btn.dataset.lensCollection;
      }
  

      showStep(target);

      // skip PD entirely for Non‑Prescription
     if (state.prescriptionType === 'Non‑Prescription' && target === '3') {
      await loadStep3Products(state.lensCollection);
      return;
    }
      // jump straight to review for Frame Only
      if (target === '5' && state.prescriptionType === 'Frame Only') {
        buildReview();
        return;
      }
      // if we’ve landed on the real Step 3, load collection
      if (target === '3') {
        await loadStep3Products(state.lensCollection);
      }
    });
  });
modal.querySelectorAll('[data-prev-step]').forEach(btn => {
  btn.addEventListener('click', e => {
    // find which panel is currently visible
    const activePanel = modal.querySelector('.lens-modal__panel.is-active').dataset.stepPanel;

    // If we’re on the Non‑Prescription “step 3” panel, Back ↳ Step 1
    if (activePanel === '3' && state.prescriptionType === 'Non‑Prescription') {
      return showStep('1');
    }
    // If we’re on the Frame Only “step 5” review panel, Back ↳ Step 1
    if (activePanel === '5' && state.prescriptionType === 'Frame Only') {
      return showStep('1');
    }

    // If we’re on the variants panel (4) *and* we previously chose a color,
    // go back to the color‐picker step instead of the generic “3”
    if (activePanel === '4' && state.color) {
      delete state.color;
      return showStep('3.1');
    }

    // Otherwise fall back to the data-prev-step attribute
    showStep(btn.dataset.prevStep);
  });
});

  
// ── 0) Cache the two PD‐container divs ──
const pdSingleDiv = modal.querySelector('.pd-single');
const pdMultiDiv  = modal.querySelector('.pd-multi');

// ── 1) Re‑wire Single vs Multi PD radios ──
modal.querySelectorAll('input[name="pd_mode"]').forEach(radio => {
  radio.addEventListener('change', e => {
    if (e.target.value === 'single') {
      pdSingleDiv.classList.remove('hidden');
      pdMultiDiv.classList.add('hidden');
    } else {
      pdSingleDiv.classList.add('hidden');
      pdMultiDiv.classList.remove('hidden');
    }
  });
});

  

// ── 2) Fix Step 2 “Next” validation ──
// Add this function to handle saving Step 2 data
function saveStep2Data() {
  const mode = modal.querySelector('input[name="pd_mode"]:checked').value;
  const pdSingle = modal.querySelector('input[name="pd_single"]').value;
  const pdRight = modal.querySelector('input[name="pd_right"]').value;
  const pdLeft = modal.querySelector('input[name="pd_left"]').value;

  if (mode === 'single') {
    state.pd = pdSingle;
  } else {
    state.pd = `${pdRight}/${pdLeft}`;
    state.pd_right = pdRight;
    state.pd_left = pdLeft;
  }

  ['sphere_od', 'cyl_od', 'axis_od', 'add_od', 'sphere_os', 'cyl_os', 'axis_os', 'add_os']
    .forEach(key => {
      const sel = modal.querySelector(`input[name="${key}"]`);
      state[key] = sel ? sel.value : '';
    });
}

// Update the step-2-next handler to call saveStep2Data()
modal.querySelector('#step-2-next').addEventListener('click', async () => {
  // Existing validation logic
  const inManual = !pdTable.classList.contains('hidden');
  const inUpload = !uploadDiv.classList.contains('hidden');

  if (inManual) {
    const anyRx = Array.from(modal.querySelectorAll('.pd-table input[type="hidden"]'))
      .some(sel => sel.value && sel.value !== '--');
    if (!anyRx) {
      vp.classList.remove('hidden');
      modal_content.classList.add('overflow-hidden')
      return;
    }
  }

  if (inUpload && selectedFiles.length === 0) {
    vp.classList.remove('hidden');
    modal_content.classList.add('overflow-hidden')
    return;
  }

  // Save data before proceeding
  saveStep2Data();

  showStep('3');
  await loadStep3Products(state.lensCollection);
});

// Update the validation popup's continue button to save data
vpContinue.addEventListener('click', () => {
  saveStep2Data(); // Save data before proceeding
  vp.classList.add('hidden');
  showStep('3');
  loadStep3Products(state.lensCollection);
});


// Modal JS
  // Elements
            const triggers = document.querySelectorAll('.custom-modal-trigger');
            const modals = document.querySelectorAll('.custom-modal-overlay');
            const closeBtns = document.querySelectorAll('.custom-modal-close');
            
            // Open modal function
            function openModal(modalId) {
                const targetModal = document.getElementById(modalId);
                if (targetModal) {
                    // Close any open modals first
                    modals.forEach(modal => modal.classList.remove('active'));
                    
                    // Open target modal
                    targetModal.classList.add('active');
                    
                    // Trap focus inside modal
                    trapFocus(targetModal);
                }
            }
            
            // Close modal function
            function closeModal(modal) {
                modal.classList.remove('active');
            }
            
            
            // Event Listeners
            triggers.forEach(trigger => {
                trigger.addEventListener('click', (e) => {
                  e.stopPropagation();
                    console.log("Clicked")
                    const modalId = trigger.getAttribute('data-modal-id');
                    openModal(modalId);
                });
            });
            
            closeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    closeModal(btn.closest('.custom-modal-overlay'));
                });
            });
            
            // Close when clicking outside modal content
            modals.forEach(modal => {
                modal.addEventListener('click', (e) => {
                    if (e.target === modal) {
                        closeModal(modal);
                    }
                });
            });

            
            

}); // DOMContentLoaded